import React, { useState } from 'react';
import { styled } from '@ff/ui';
import type { Props } from './props-schema';
import SingleCard from './SingleCard';
import FlexCol from '@ff/ui/FlexCol';
import DoubleCards from './DoubleCards';
import MultipleCards from './MultipleCards';
import BioModal from './BioModal';
import useIsBreakpoint from '@ff/ui/utils/useIsBreakpoint';
import MobileCards from './MobileCards';
import Text from '@ff/ui/Text';

export default function CharacterBio(props: Props) {
  const { title, subtitle, readBio, bioList, backgroundColor, textColor } = props;

  const isMd = useIsBreakpoint('md');
  const [content, setContent] = useState(null);

  let DesktopCards;

  if (bioList.length === 1) {
    DesktopCards = SingleCard;
  } else if (bioList.length === 2) {
    DesktopCards = DoubleCards;
  } else if (bioList.length > 2) {
    DesktopCards = MultipleCards;
  }

  return (
    <Container bgColor={backgroundColor}>
      <Content>
        <TitleContainer>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TitleContainer>
        {isMd
          ? <DesktopCards readBio={readBio} bioList={bioList} textColor={textColor} onBioClick={(item) => setContent(item)} />
          : <MobileCards readBio={readBio} bioList={bioList} textColor={textColor} onBioClick={(item) => setContent(item)} />
        }
      </Content>
      <BioModal content={content} onClose={() => setContent(null)} />
    </Container>
  )
}

const Container = styled(FlexCol)<{ bgColor?: string }>(({ theme, bgColor }) => ({
  alignItems: 'center',
  padding: '46px 16px',
  backgroundColor: bgColor || 'rgba(34, 34, 36, 1)',

  [theme.mediaQueries.sm]: {
    padding: '46px 32px'
  },
}));

const Content = styled(FlexCol)({
  maxWidth: '1438px'
});

const TitleContainer = styled(FlexCol)();

const Title = styled(Text)({
  color: 'rgba(244, 244, 244, 1)',
  fontSize: '30px',
  lineHeight: '42px'
});

const Subtitle = styled(Text)({
  color: 'rgba(201, 201, 209, 1)',
  fontSize: '15px',
  lineHeight: '26px'
});
